<template>
  <div v-if="adresse">
    <div class="columns">
      <div class="column is-6">
        <b-field :label="$t('address.address')"
                 custom-class="has-text-weight-normal is-italic is-marginless">
          <div class="mgb-20px mgt-20px mgl-10px">
            <adresse-detail :adresse="adresse" classLigne="has-text-weight-bold">
            </adresse-detail>
          </div>
        </b-field>
        <div class="columns is-multiline">
        <b-field :label="$t('address.lat')" class="column is-6"
                 custom-class="has-text-weight-normal is-italic is-marginless">
          <p class="has-text-weight-bold">{{adresse.latitude}}</p>
        </b-field>
        <b-field :label="$t('address.long')" class="column is-6"
                 custom-class="has-text-weight-normal is-italic is-marginless">
          <p class="has-text-weight-bold">{{adresse.longitude}}</p>
        </b-field>
        </div>
      </div>
      <gmap-map class="column is-6 is-height-320 mgt-20px mgb-20px" :center="center"
                :zoom="adresse.longitude !== null
                || adresse.latitude !== null
                ? zoomDefault : zoomDefaultSansMarker">
        <gmap-marker :key="m.num" v-for="(m) in markers"
                     :position="m.position" :icon="m.icon">
        </gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>

import markersGetter from '@/services/general/map/markersGetter';
import centerMapGetter from '@/services/general/map/centerMapGetter';
import {
  ZOOM_DEFAULT_EMPLACEMENT, CENTER_DEFAULT, ZOOM_DEFAULT_SANS_MARKER, COULEUR_PUCE_RED,
} from '@/configuration/general/carteConf';
import adresseDetail from '@/components/general/adresseDetail';

export default {
  data() {
    return {
      zoomDefault: ZOOM_DEFAULT_EMPLACEMENT,
      zoomDefaultSansMarker: ZOOM_DEFAULT_SANS_MARKER,
    };
  },
  props: {
    adresse: {
      type: Object,
      required: true,
    },
  },
  components: {
    adresseDetail,
  },
  computed: {
    markers() {
      return markersGetter(this.adresse, COULEUR_PUCE_RED);
    },
    center() {
      if (this.adresse.longitude !== null
        && this.adresse.latitude !== null) {
        return centerMapGetter(this.adresse, this.markers);
      }
      return centerMapGetter(CENTER_DEFAULT, []);
    },
  },
};
</script>

<style scoped>

</style>
